export const getLimitedData = (arr = null, reqLength, fromLast = false) => {
    if (arr == null)
        return void 0;
    if (!reqLength)
        return arr[arr.length - 1];
    if (fromLast) {
        return arr.slice(Math.max(arr.length - reqLength, 0));
    }
    else {
        return arr.slice(0, reqLength);
    }
};
